import { CollaborationResult, ICollaboration } from '@descomplica/microfrontend-core';
import { injectable } from 'tsyringe';

import {
  GetStreamingByGuidInput,
  getStreamingByGuidResponse,
} from '@/application/interfaces/classroom/pegasus.gateway';
import { PegasusGateway } from '@/infrastructure/gateways/classroom/pegasus.gateway';

@injectable()
export class GetStreamingByGuidCollaboration
  implements
    ICollaboration<GetStreamingByGuidInput, CollaborationResult<getStreamingByGuidResponse>>
{
  constructor(private readonly pegasusGateway: PegasusGateway) {}

  public async run({ courseGuid, streamingGuid }: GetStreamingByGuidInput) {
    return this.pegasusGateway.getStreamingByGuid({ courseGuid, streamingGuid });
  }
}
